import type { UserPublicMe } from "@common/client"

export function hasPermission(
  user: UserPublicMe | undefined,
  permission: string,
): boolean {
  if (!user) return false
  if (user.is_system_user) return true
  return grantsPermission(user.permissions ?? [], permission)
}

export function grantsPermission(
  permissions: string[],
  permission: string,
): boolean {
  const wildcard = `${permission.split(":")[0]}:*`
  return permissions.some((p) => p === permission || p === wildcard)
}

export function hasRolePermission(
  user: UserPublicMe | undefined,
  permission: string,
): boolean {
  return user?.permissions?.includes(permission) === true
}
